import { Box, Typography, styled } from '@mui/material'
import { Link } from 'react-router-dom'

export const StyledHeading = styled(Typography)(({ theme: { spacing, palette } }) => ({
  margin: spacing(3, 0, 1),
  color: palette.common.primaryBase,
  marginTop: spacing(4),
}))

export const StyledDescription = styled(Typography)(({ theme: { spacing, palette } }) => ({
  textAlign: 'center',
  color: palette.common.primaryBase,
  margin: spacing(1, 0, 3),
}))

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const StyledLink = styled(Link)(
  ({
    theme: {
      palette: {
        common: { primaryBase },
      },
    },
  }) => ({
    color: primaryBase,
    '&:active': {
      color: primaryBase,
    },
  }),
)
